import type { participantes as pt } from '../pt-BR/participantes';
import type { Traducao } from '../Traducao';

export const participantes = {
  secao: 'Participantes',
  elegiveis: 'En la campaña: {{n}}',
  excluidos: 'Excluidos: {{n}}',
  acionadaPor: 'Accionada por',
  contagens: {
    incluidos: 'Incluidos en esta sincronización',
    alterados: 'Modificados',
    reativados: 'Reactivados',
    excluidos: 'Excluidos en esta sincronización',
    ignorados: 'Ignorados',
  },
  resultado: { sucesso: 'Éxito', falha: 'Fallo' },
  confirmar:
    'Esto consulta Axiis, incluye a los profesionales activos que aún no están en la campaña, actualiza los datos de quienes ya están y marca como excluidos a los desvinculados. No se elimina ninguna respuesta. ¿Continuar?',
  confirmarAtivacao: 'El enlace pasa a aceptar respuestas.',
  sincronizado: 'Sincronización completada: {{incluidos}} incluidos, {{excluidos}} excluidos.',
  falhou: 'La sincronización falló. Consulta el motivo en el resumen.',
  status: {
    sincronizada_one: 'Sincronizado el {{quando}} · {{count}} en la campaña',
    sincronizada_other: 'Sincronizado el {{quando}} · {{count}} en la campaña',
    sincronizadaEm: 'Sincronizado el {{quando}}',
    detalhes: 'Detalles',
  },
  aba: 'Participantes',
  painel: {
    totais: {
      elegiveis: 'En la campaña',
      responderam: 'Respondieron',
      naoResponderam: 'No respondieron',
      queremBrinde: 'Quieren el obsequio',
      exterior: 'Reciben en el extranjero',
    },
    filtros: {
      busca: 'Nombre, correo o matrícula',
      buscaChip: 'Búsqueda',
      respondeu: 'Respuesta',
      brinde: 'Obsequio',
      axiis: 'Grabación en Axiis',
      convite: 'Invitación',
      todos: 'Todos',
      sim: 'Sí',
      nao: 'No',
      falha: 'Con fallo',
      pendente: 'Pendiente',
      falhaOuPendente: 'Fallo o pendiente',
      situacao: 'Situación',
      rotulo: '{{filtro}}: {{valor}}',
    },
    situacao: { elegivel: 'En la campaña', excluido: 'Excluidos' },
    colunas: {
      matricula: 'Matrícula',
      nome: 'Nombre',
      resposta: 'Respuesta',
      brinde: 'Obsequio',
      camiseta: 'Camiseta',
      endereco: 'Dirección',
      atualizadaEm: 'Actualizada el',
      acoes: 'Acciones',
      convite: 'Invitación',
    },
    respondeu: 'Respondió',
    naoRespondeu: 'No respondió',
    entrega: {
      cadastro: 'Registro',
      outro: 'Otra',
      exterior: 'Extranjero',
      sem: 'Sin dirección de entrega',
    },
    oficial: 'Oficial: {{situacao}}',
    gravacao: { sucesso: 'Grabada', pendente: 'Pendiente', falha: 'Fallo', cancelada: 'Cancelada' },
    vazio: 'Ningún participante. Sincronice la campaña.',
    semResultado: 'Ningún participante con estos filtros.',
  },
  linha: { abrir: 'Abrir {{nome}}' },
  detalhe: {
    titulo: 'Detalles del participante',
    semResposta: 'Esta persona aún no ha respondido.',
    semAlteracaoOficial: 'Sin cambios',
    matricula: 'Matrícula {{matricula}}',
    nome: 'Nombre',
    nomeSocial: 'Nombre social',
    nomePrefer: 'Nombre preferido',
    incluidoEm: 'Incluido el',
    primeiroAcesso: 'Primer acceso',
    camiseta: 'Camiseta',
    versao: 'Versión',
    primeiraResposta: 'Primera respuesta',
    ultimaResposta: 'Última respuesta',
    tentativas: '{{n}} intentos',
    itemCamiseta: 'Camiseta',
    itemEndereco: 'Dirección oficial',
    retentar: 'Intentar grabar de nuevo',
    retentado_zero: '{{count}} grabados, {{falha}} con fallo.',
    retentado_one: '{{count}} grabado, {{falha}} con fallo.',
    retentado_other: '{{count}} grabados, {{falha}} con fallo.',
    retentadoNada: 'Nada que grabar.',
    elegivel: 'En la campaña',
    excluido: 'Excluido',
    erro: 'Error al cargar el participante.',
    erroLista: 'Error al cargar los participantes.',
    secoes: {
      identificacao: 'Identificación',
      apresentado: 'Presentado al profesional',
      respostas: 'Respuestas',
      entrega: 'Dirección de entrega',
      oficial: 'Dirección oficial',
      confirmacoes: 'Confirmaciones',
      axiis: 'Grabación en Axiis',
      convite: 'Invitación',
    },
    fotografiaEm: 'Fotografía de',
    enderecoApresentado: 'Dirección',
    confirmacoesLinha: 'Dirección correcta: {{correto}} · Alguien para recibir: {{recebedor}}',
    tentativa: '{{n}} intento',
  },
  abas: { naCampanha: 'En la campaña', excluidos: 'Excluidos' },
  lote: {
    enviarEmail: 'Enviar e-mail',
    barra: 'Acciones en lote',
    selecionados_one: '{{count}} seleccionado',
    selecionados_other: '{{count}} seleccionados',
    selecionarPagina_one: 'Seleccionada {{count}} de esta página.',
    selecionarPagina_other: 'Seleccionadas {{count}} de esta página.',
    selecionarPaginaRotulo: 'Seleccionar las filas de esta página',
    selecionarLinha: 'Seleccionar a {{nome}}',
    selecionarTodosFiltro: 'Seleccionar los {{total}} que cumplen los filtros',
    selecionarTodos: 'Seleccionar todos ({{total}})',
    todosDoFiltroAtivo: '(todos los que cumplen los filtros)',
    foraDaLista_one: '{{count}} no aparece en esta lista',
    foraDaLista_other: '{{count}} no aparecen en esta lista',
    verSelecionados: 'Ver seleccionados',
    selecionadosTitulo: 'Personas seleccionadas',
    tirar: 'Quitar a {{nome}} de la selección',
    tirarBotao: 'Quitar',
    eMais_one: 'y {{count}} persona más',
    eMais_other: 'y {{count}} personas más',
    limpar: 'Limpiar selección',
    excluir: 'Excluir de la campaña',
    devolver: 'Devolver a la campaña',
    excluirLinha: 'Excluir a {{nome}}',
    devolverLinha: 'Devolver a {{nome}}',
    excluirTitulo_one: '¿Excluir a {{count}} persona de la campaña?',
    excluirTitulo_other: '¿Excluir {{count}} de la campaña?',
    devolverTitulo_one: '¿Devolver a {{count}} persona a la campaña?',
    devolverTitulo_other: '¿Devolver {{count}} a la campaña?',
    excluirCorpo_one:
      'Esta persona sale de la lista, no recibe invitaciones y no entra en la exportación. La respuesta ya enviada se mantiene. La sincronización no la trae de vuelta; para volver, use "Devolver a la campaña".',
    excluirCorpo_other:
      'Estas personas salen de la lista, no reciben invitaciones y no entran en la exportación. Las respuestas ya enviadas se mantienen. La sincronización no las trae de vuelta; para volver, use "Devolver a la campaña".',
    devolverCorpo_one:
      'Esta persona vuelve a la lista de la campaña. Si está inactiva en el registro, no vuelve.',
    devolverCorpo_other:
      'Estas personas vuelven a la lista de la campaña. Quien está inactivo en el registro no vuelve.',
    comResposta_one: '{{count}} ya respondió; la respuesta se mantiene.',
    comResposta_other: '{{count}} ya respondieron; las respuestas se mantienen.',
    resultado: '{{processados}}, {{ignorados}}.',
    soProcessados: '{{processados}}.',
    processados_zero: '{{count}} procesados',
    processados_one: '{{count}} procesado',
    processados_other: '{{count}} procesados',
    ignoradosLote_one: '{{count}} ignorado',
    ignoradosLote_other: '{{count}} ignorados',
    verMotivos: 'Ver motivos',
    motivosTitulo: 'Personas ignoradas',
    desatualizada: 'La lista cambió desde que usted seleccionó. Revise e inténtelo de nuevo.',
  },
  codigos: {
    INATIVO_NO_AXIIS: 'Inactivo en el registro',
    JA_PARTICIPANTE: 'Ya es participante',
    NAO_ENCONTRADO_NO_AXIIS: 'No encontrado en el registro',
    JA_EXCLUIDO: 'Ya estaba excluido',
    NAO_EXCLUIDO: 'Ya estaba en la campaña',
    PARTICIPANTE_NAO_ENCONTRADO: 'Participante no encontrado',
  },
  incluir: {
    botao: 'Agregar participante',
    titulo: 'Agregar participantes a la campaña',
    busca: 'Buscar por nombre o matrícula',
    somenteAtivos: 'Solo aparecen personas activas en el registro que aún no están en la campaña.',
    semResultado: 'Nadie encontrado para esta búsqueda.',
    tentarDeNovo: 'Intentar de nuevo',
    adicionar: 'Agregar {{count}}',
  },
  idiomas: { PT: 'Portugués', EN: 'Inglés', ES: 'Español' },
  colunas: {
    idioma: 'Idioma',
    titulo: 'Columnas',
    visiveis: 'Columnas visibles',
    redefinir: 'Restablecer',
    aplicar: 'Aplicar',
    nenhuma: 'Elija al menos una columna.',
    email: 'Correo electrónico',
    acessos: 'Accesos',
    ultimoAcesso: 'Último acceso',
    origem: 'Origen',
    por: 'Excluido por',
  },
  origem: { sincronizacao: 'Sincronización', manual: 'Manual', axiis: 'Registro (Axiis)' },
  acessos: { nunca: 'Nunca', janela: 'Contamos una nueva visita cada 30 minutos.' },
  filtros: {
    avancados: 'Filtros',
    limparTudo: 'Limpiar todo',
    fechar: 'Cerrar',
    acessou: 'Accedió',
    temEmail: 'Tiene e-mail',
    respondidaEm: 'Respondida el',
    aplicados: 'Filtros aplicados',
    remover: 'Quitar filtro {{filtro}}',
  },
  porPagina: 'Elementos por página',
  vazio: {
    excluidos: 'Nadie fue excluido de esta campaña.',
    titulo: 'Nadie en la campaña todavía',
    descricao: 'Traiga a los profesionales activos de Axiis. Después excluya a quien no recibe.',
  },
  inicioEFim: 'Inicio y fin',
} as const satisfies Traducao<typeof pt>;
